import gql from 'graphql-tag';

export default gql`
query getAllPersonalizationGroupsForAtLeastManager($userId: Int!) {
  users_by_pk(user_id: $userId) {
    sys_admin
  }
  users_roles_groups(
    where: {
      group: {
        groups_privileges: {
          _and: {
            privilege: {handle: {_eq: "can_use_personalization"}},
            value: {_cast: {String: {_eq: "true"}}}
          }
        }
      },
      role_id: {_lt: 4},
      user_id: {_eq: $userId}
    }
  ) {
    group_id
  }
}
`;
